import router from '@/router'
import { isMobile } from 'mobile-device-detect';
import { dgaSocket } from '../../plugins/pragmaticdga.js'
const state = {
  in_play: false,
  games: [],
  search: null,
  game_url: null,
  step: 1,
  currentCategory: '12',
  currentProvider: 'pragmaticplay',
  categories:[],
  providers : [],
}
const getters = {
  getStep(state){
    return state.step;
  },
  getInPlay(state){
    return state.in_play;
  },
  getSearch(state){
    return state.search;
  },
  getGames(state){
    return state.games;
  },
  getGameUrl(state){
    return state.game_url;
  },
  getCurrentProvider(state){
    return state.currentProvider;
  },
  getCurrentCategory(state){
    return state.currentCategory;
  },
  getCategories(state){
    return state.categories;
  },
  getProviders(state){
    return state.providers;
  },
}
const mutations = {
    setStep(state, val){
      return state.step = val;
    },
    setInPlay(state, val){
      return state.in_play = val;
    },
    setSearch(state, val){
      return state.search = val;
    },
    setGames(state, val){
      return state.games = val;
    },
    setGameDetail(state, val){
      if(_.find(state.games, ['game_id', val.id])){
        return _.find(state.games, ['game_id', val.id]).details = val.details;
      }
    },
    setGameUrl(state, val){
      return state.game_url = val;
    },
    setCurrentProvider(state, val){
      return state.currentProvider = val;
    },
    setCurrentCategory(state, val){
      return state.currentCategory = val;
    },
    setCategories(state, val){
      return state.categories = val;
    },
    setProviders(state, val){
      return state.providers = val;
    },
}
const actions = {
  initCasino({ commit, state, dispatch }) {
        commit('setInPlay', false);
        commit('setGameUrl', null);
        dgaSocket.connect('dga.fugkdcwicfwhvnzx.net')
			  return axios.get('games/casino')
          .then((response) => {
          commit('setGames', response.data.games);
          commit('setCategories', response.data.categories_v2);
          commit('setProviders', (_.sortBy(response.data.sorts, [function (o) { return o.sort; }])));
          if (router.currentRoute.params.category) {
            commit('setCurrentCategory', router.currentRoute.params.category)
          }
          if(!router.currentRoute.params.provider && !router.currentRoute.params.category) {
            router.replace({ params: { category: state.currentCategory, provider: state.currentProvider }});
          }
          if (router.currentRoute.params.provider) {
            commit('setCurrentProvider', router.currentRoute.params.provider)
            
          }
          if(router.currentRoute.query.game_id && router.currentRoute.query.mobile) {
            dispatch('runGame', { id: router.currentRoute.query.game_id, device: router.currentRoute.query.mobile });
          }
				})
				.catch((err) => {
				});
  },
  runGame({ commit, dispatch }, payload) {
      commit('setInPlay', true);
      router.replace({ query: { game_id: payload.id, mobile: payload.device }});
      axios.get('games/casino/launch', { params:{ game_id : payload.id, mobile: payload.device } })
      .then((response) => {
          if (!response.data.config.is_script && isMobile) {
            location.href = response.data.config.url;
            // var open = window.open(response.data.config.url, '_blank');
            // open
            // if (open == null || typeof(open)=='undefined'){
            //   alert("Oyuna giriş sağlayabilmek için lütfen tarayıcınızda Pop-Up etkinliğine izin veriniz.");
            // }
            dispatch('closeGame');
          } else {
            commit('setGameUrl', response.data);
          }
      })
      .catch((err) => {
      });
  },
  closeGame({ commit }) {
    commit('setInPlay', false);
    commit('setGameUrl', null);
    router.replace({ params: { category: state.currentCategory, provider: state.currentProvider }});
  },
  changeCategory({ commit, state }, [category]) {
    commit('setSearch', null);
    commit('setCurrentCategory', category);
    router.replace({ params: { category: category, provider: state.currentProvider }});
  },
  changeProvider({ commit }, [provider]) {
    commit('setSearch', null);
    commit('setCurrentProvider', provider);
    commit('setCurrentCategory', 'all');
    router.replace({ params: { category: state.currentCategory, provider: provider }});
  },
  search({ commit }, payload) {
    commit('setSearch', payload);
  },
}

export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions,
}